import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  getSelectedZusatzoptionen,
  GlobalActions,
  GlobalPut,
  RsCheckoutProduktPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, Produktlinie, VersicherterBereichEnum } from '@ps20-frontend/frontend-models';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { FahrzeugeVersichert } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { RsActions } from '../rsActions';

export function* watchInDashboardUebernehmenSaga() {
  yield takeEvery(RsActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateDashboardData, App.RS));
  yield takeEvery(RsActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateProduktData, App.RS));
}

export function* generateProduktData() {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();
  const isAuslaendischeAdresse = state.vermieteteObjekte
    ? state.vermieteteObjekte.some(c => c.auslaendischeAdresse)
    : false;

  const produktData: RsCheckoutProduktPayload = {
    appId: App.RS,
    laufzeit: state.vertragsoptionen.vertragslaufzeit,
    uebersichtTitle: 'Rechtsschutzversicherung',
    versichertesRisiko: `${state.risikoort.strasse} ${state.risikoort.hausnummer}, ${state.risikoort.plz} ${state.risikoort.ort}`,
    hasEinFahrzeugVersichert:
      state.vertragsoptionen.versicherterBereich === VersicherterBereichEnum.VERKEHR &&
      state.vertragsoptionen.fahrzeug.anzahlFahrzeug === FahrzeugeVersichert.EINS,
    vorvertragsnummer: state.vertragsoptionen.vorvertragsNummern,
    isKombischutzSelected:
      state.vertragsoptionen.versicherterBereich === VersicherterBereichEnum.KOMBI,
    vorvertragSofortschutz: state.vertragsoptionen.vorvertragSofortschutz,
    beginndatum: state.vertragsoptionen.beginnDatum,
    isImmobilieImAusland: isAuslaendischeAdresse,
    angebotsdatum: state.vertragsoptionen.angebotsdatum,
    kennzeichen: state.vertragsoptionen.fahrzeug?.amtlichesKennzeichen,
  };
  yield call([globalPut, globalPut.put], new GlobalActions().produktAction(produktData));
}

export function* generateDashboardData() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const selectedProduktlinie: Produktlinie = getSelectedProduktlinie(state.produkt);
  yield put(new RsActions().vorschlagdatenChanged());
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().inDashboardUebernehmen({
      appId: App.RS,
      kurztext: selectedProduktlinie.kurztext,
      ausgewaehlteLinie: selectedProduktlinie.produktName,
      versichertesRisiko: `${state.risikoort.strasse} ${state.risikoort.hausnummer}, ${state.risikoort.plz} ${state.risikoort.ort}`,
      vertragslaufzeit: state.vertragsoptionen.vertragslaufzeit,
      selectZusatzoptionen: getSelectedZusatzoptionen(selectedProduktlinie.zusatzoptionen),
      beginn: state.vertragsoptionen.beginnDatum,
    }),
  );
}
